import React from 'react';
import InviteMember from "./InviteMember";
import Translate from "../../../../../components/Translate";
import BlueButton from "../../../../../components-new/buttons/BlueButton";
import TranslateProperty from "../../../../../components/TranslateProperty";
import FileUpload from "../../../../../components-new/general/FileUpload";
import Input from "../../../../../components-new/form/Input";
import Tooltip from "../../../../../components-new/general/Tooltip";
import DropdownSelect from "../../../../../components-new/form/DropdownSelect";
import Checkbox from "../../../../../components-new/form/Checkbox";
import './InviteEmployees.css';

const InviteEmployees = ({
                             user,
                             company,
                             addNotification,
                             fetchCompany,
                             email,
                             username,
                             firstName,
                             lastName,
                             password,
                             thumbUrl,
                             role,
                             language,
                             roles,
                             locales,
                             canChangeHimselfInfo,
                             handleChange,
                             handleThumbUrlDelete,
                             handleAddUser,
                             handleHimselfInfoCheckboxChange,
                             setState,
                             localFile,
                             iconMap
                         }) => {

    return (

        <div className="invite-employees">
            <section className="invite-employees__card">
                <header className="invite-employees__card-header">
                    <h2><Translate text="inviteMembers"/></h2>
                </header>
                <div className="invite-employees__card-content">
                <InviteMember
                    user={user}
                    company={company}
                    addNotification={addNotification}
                    fetchCompany={fetchCompany}
                />
                </div>
            </section>

            <section className="invite-employees__card">
                <header className="invite-employees__card-header">
                    <h2><Translate text="add"/> <Translate text="employee"/></h2>
                </header>

                <div className="invite-employees__card-content invite-employees__details-layout">
                    <div className="invite-employees__avatar">
                        <FileUpload
                            windowSize={96}
                            svgSize={40}
                            imgSize={88}
                            progressSize={96}
                            uploadOnSelect={false}
                            handleChange={(file) => setState({localFile: file})}
                            handleDelete={() => setState({localFile: null})}
                            image={localFile instanceof File ? URL.createObjectURL(localFile) : thumbUrl}
                        />
                    </div>

                    <div className="invite-employees__form">
                        <div className="invite-employees__fields">
                            <TranslateProperty properties={[{key: 'placeholder', value: 'email*'}]}>
                                <Input controlled onChange={(e) => handleChange('email')(e.target.value)} value={email}/>
                            </TranslateProperty>
                            <TranslateProperty properties={[{key: 'placeholder', value: 'username*'}]}>
                                <Input controlled onChange={(e) => handleChange('username')(e.target.value)} value={username}/>
                            </TranslateProperty>
                            <TranslateProperty properties={[{key: 'placeholder', value: 'firstName*'}]}>
                                <Input controlled onChange={(e) => handleChange('firstName')(e.target.value)} value={firstName}/>
                            </TranslateProperty>
                            <TranslateProperty properties={[{key: 'placeholder', value: 'lastName*'}]}>
                                <Input controlled onChange={(e) => handleChange('lastName')(e.target.value)} value={lastName}/>
                            </TranslateProperty>
                            <TranslateProperty properties={[{key: 'placeholder', value: 'password*'}]}>
                                <Input controlled onChange={(e) => handleChange('password')(e.target.value)} value={password}/>
                            </TranslateProperty>

                            <DropdownSelect
                                options={roles}
                                selectedValue={role}
                                onChange={handleChange('role')}
                                variant='outline'
                                renderLabel={
                                    (val) => val.title
                                }
                                styles={{color: 'var(--ds-text-primary)', width: '100%'}}
                            >
                                {(option) => option.title}
                            </DropdownSelect>

                            <DropdownSelect
                                options={locales}
                                selectedValue={locales.find(locale => locale.value === language.value)}
                                onChange={handleChange('language')}
                                variant='outline'
                                renderLabel={
                                    (val) => {
                                        return (
                                            <div style={{display: 'flex', gap: '10px', alignItems: 'center'}}>
                                                {iconMap[val.value]}
                                                <span>{val.title.toUpperCase()}</span>
                                            </div>
                                        )
                                    }
                                }
                                styles={{color: 'var(--ds-text-primary)', width: '100%'}}
                            >
                                {(option) =>
                                    <div style={{display: 'flex', gap: '10px', alignItems: 'center'}}>
                                        {iconMap[option.value]}
                                        <span>{option.title}</span>
                                    </div>
                                }
                            </DropdownSelect>
                        </div>

                        <div className="invite-employees__permission">
                            <Tooltip text={'operatorCanChangeHimselfInfo'}>
                                <Checkbox
                                    handleChange={handleHimselfInfoCheckboxChange}
                                    checked={canChangeHimselfInfo}
                                    label={
                                        <span><Translate text={'allowEdit'}/></span>
                                    }
                                />
                            </Tooltip>
                        </div>

                        <div className="invite-employees__actions">
                        <BlueButton
                            type="button"
                            width="120px"
                            height="36px"
                            onClick={handleAddUser}
                            children={<Translate text="add"/>}
                        />
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default InviteEmployees;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/members/InviteEmployees.jsx